module.exports = __webpack_public_path__ + "img/ccdshynewtext.42bf5f51.png";